// extracted by mini-css-extract-plugin
export default {"container":"SuperAdmin_container__B+00v","content":"SuperAdmin_content__WQoMi","mainContent":"SuperAdmin_mainContent__5N46E","sectionContent":"SuperAdmin_sectionContent__AJYIf"};